// Top-level provider/rate-limit error surface. Keeps the amber icon +
// two-line copy identical to the original inline component.
export function ErrorCard({ testid, icon: Icon, title, body }) {
  return (
    <section
      data-testid={testid}
      className="pa-card p-6 md:p-8 mt-6 md:mt-8"
    >
      <div className="flex items-start gap-3">
        <Icon size={22} style={{ color: "#b45309" }} />
        <div>
          <h3 className="font-display text-lg md:text-xl uppercase tracking-wide text-slate-900">
            {title}
          </h3>
          <p className="mt-1 text-slate-600 text-sm">{body}</p>
        </div>
      </div>
    </section>
  );
}
